import React, { createContext, useState } from "react";
import { useData } from "../general/DataContext";

export const PersonelContext = createContext();

export const PersonelProvider = ({ children }) => {
  const { statusdata, citiesdata } = useData(); 
  const workTypeOptions = ["Tam Zamanlı", "Vardiya", "Part-Time"];

  const [personelList, setPersonelList] = useState([
    {
      id: 1,
      fullName: "Ahmet Yılmaz",
      email: "ahmet@example.com",
      password: "123456",
      company: "ABC Ltd.",
      position: "Tekniker",
      phone: "0555 123 45 67",
      city: "İstanbul",
      district: "Kadıköy",
      address: "Bahariye Cad",
      status: statusdata[0], 
      workType: workTypeOptions[0], 
    },
    {
      id: 2,
      fullName: "Mehmet Kaya",
      email: "mehmet@example.com",
      password: "abcdef",
      company: "XYZ A.Ş.",
      position: "Mühendis",
      phone: "0555 987 65 43",
      city: "Ankara",
      district: "Çankaya",
      address: "Atatürk Bulv",
      status: statusdata[1],
      workType: workTypeOptions[1], 
    },
  ]);

  // Personel ekleme
  const addPersonel = (personel) => {
    const newId =
      personelList.length > 0
        ? Math.max(...personelList.map((p) => p.id)) + 1
        : 1;
    const newPersonel = { ...personel, id: newId };
    setPersonelList((prev) => [...prev, newPersonel]);
  };

  // Personel güncelleme
  const updatePersonel = (id, updatedData) => {
    setPersonelList((prev) =>
      prev.map((p) => (p.id === id ? { ...p, ...updatedData } : p))
    );
  };

  // Personel silme
  const deletePersonel = (id) => {
    setPersonelList((prev) => prev.filter((p) => p.id !== id));
  };

  return (
    <PersonelContext.Provider
      value={{
        personelList,
        addPersonel,
        updatePersonel,
        deletePersonel,
        statusdata,
        workTypeOptions,
        citiesdata,
      }}
    >
      {children}
    </PersonelContext.Provider>
  );
};
